export default __webpack_public_path__ + "static/media/mobile-background.5b221cf0.svg";